var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.html_value),callback:function ($$v) {_vm.html_value=$$v},expression:"html_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }